// © 2026 Orpyx Medical Technologies Inc.

import React, {memo, useEffect} from "react";
import {PatientActivityLogSuggestedActionProps} from "./patient-activity-log-suggested-action.interface";

const UnrecognisedSuggestedActionText = 'Unrecognised suggested action';

export const PatientActivityLogSuggestedAction = memo((props: PatientActivityLogSuggestedActionProps) => {
    const recognised: boolean = !!props.suggestedActionText;

    // The API still resolves retired suggested actions, so a missing text means the note's id is
    // absent from the API's own list - the two lists have drifted apart. Only the id is logged.
    useEffect(() => {
        if (!recognised) {
            console.warn(`Care note references suggested action ${props.suggestedActionTypeId}, which the API could not resolve to a name`);
        }
    }, [recognised, props.suggestedActionTypeId]);

    return <div className={props.classes.suggestedAction}>
        <span className={props.classes.suggestedActionLabel}>
            Suggested Action
        </span>

        <p className={props.classes.suggestedActionText}>
            {props.suggestedActionText || UnrecognisedSuggestedActionText}
        </p>

        {props.suggestedActionOwner &&
        <span className={props.classes.suggestedActionOwner}>
            {props.suggestedActionOwner}
        </span>}
    </div>;
});
